import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { Outlet } from "react-router-dom";

import { theme } from "#app/theme/v1";

export const PublicLayout = () => (
  <MantineProvider theme={theme}>
    <Notifications position="top-right" />
    <Outlet />
  </MantineProvider>
);
